import { Injectable } from '@angular/core';
import { BehaviorSubject, forkJoin } from 'rxjs';
import { ImageService } from './image.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
 providedIn: 'root'
})

export class PrintPreviewService {
  private selectedDocuments = new BehaviorSubject<{fileId: number, type: number}[]>([]);
  selectedDocuments$ = this.selectedDocuments.asObservable();

  constructor(
    private imageService: ImageService,
    private toastr: ToastrService,
    private translateService: TranslateService
  ) {}

  setSelectedDocuments(documents: {fileId: number, type: number}[]): void {
    this.selectedDocuments.next(documents);
  }

  getSelectedDocuments(): {fileId: number, type: number}[] {
    return this.selectedDocuments.value;
  }

  hasSelectedDocuments(): boolean {
    return this.selectedDocuments.value.length > 0;
  }

  clearSelection(): void {
    this.selectedDocuments.next([]);
  }

  printSelectedDocuments(): void {
    const documents = this.selectedDocuments.value;
    if (documents.length === 0) return;

    const printRequests = documents.map(doc => 
      this.imageService.getImage(doc.fileId, doc.type)
    );

    forkJoin(printRequests).subscribe(responses => {
      const images = responses
        .filter(response => response.status !== 204)
        .map(response => response.body);

      if (images.length === 0) {
        return;
      }

      this.createPrintWindow(images);
    });
  }
  
 createPrintWindow(images: any[]): void {
  const printWindow = window.open('', '_blank', 'width=800,height=1000');
  if (!printWindow) {
    this.toastr.error(this.translateService.instant('documents.open-print-window-failed'));
    return;
  }
  
  const svgElements = images.map(svgString => 
    `<div style="margin-bottom: 20px;">${svgString}</div>`
  ).join('');
 
  printWindow.document.open();
  printWindow.document.write(`
    <html>
      <head>
        <style>
          body { margin: 0; padding: 20px; }
          svg { width: 100%; height: auto; }
          @media print { 
            svg { width: 50%; height: auto; }
          }
        </style>
      </head>
      <body>
        ${svgElements}
        <script>
          window.onload = function() {
            window.print();
          }
        </script>
      </body>
    </html>
  `);
  printWindow.document.close();
 }
}